<script setup>

</script>

<template>
  <div ml="8%">
    <div w="95%" mt-24 mb-24>
      <div class="about-warp__right--title">
      {{ $t('fdzq') }}
    </div>
    <div class="about-warp__right--content intro-box">
      <h4>{{ $t('jj') }}</h4>
      <p>{{ $t('fdzqyxgsyxjcfdxgcly2015n8ysyjlzxgmxndfyqqdgjjrjgwgrhjgtzztgqqzqyqhjjfwcyxgzjhbfd1245lsgghdpz') }}</p>
      <p>{{ $t('fdxgyzydzyszhcxdhyjswgbryjqzlywkhtgpzffdtzcpwdgxdjypthzybjdjrfw') }}</p>
      <h4 class="doc-title">{{$t('ywys')}}</h4>
      <p style="font-weight: 600;">{{$t('zyt')}}</p>
      <p>{{$t('khgaqgfbgqdqcsjczzbchmfzxsqkhdtkhdtrjjy')}}</p>
      <p style="font-weight: 600;">{{$t('gaq')}}</p>
      <p>{{$t('khzlqcjbmbhwjkhbryxbxrhdsfplrhkhzlys')}}</p>
      <p style="font-weight: 600;">{{$t('gfb')}}</p>
      <p>{{$t('zbchsssdzxsqkhqcmfbysfmgxg')}}</p>
      <p style="font-weight: 600;">{{$t('gqd')}}</p>
      <p>{{$t('ygfdzhqqtzzs')}}</p>
    <!--  <p> · {{$t('zcggmgaghsgtzsqhhjqhetf')}}</p>
      <p> · {{$t('ggtzyzgpxgrggggd20b')}}</p> -->
      <h4 class="doc-title">{{ $t('sm') }}</h4>
      <p class="not-indent">{{ $t('zywddhlwqs') }}</p>
      <h4 class="doc-title">{{ $t('yj') }}</h4>
      <p class="not-indent">{{ $t('cwqqhrsqzjyxldgrtzyjyfwqs') }}</p>
      <img src="https://tg.fdzq.com/img/forthright-sec/images/about/intro-logo@2x.png" alt="LOGO" title="LOGO">
    </div>
    </div>

  </div>
</template>
<style lang="less" scoped>
@import "../../assets/less/main.less";
@import "../assets/css/about.less";
.intro-box {
  color: #61676B;
  .font-size-line(14, 20);

  h4 {
    color: #1D2228;
  }

  p {
    // text-indent: 2em;
    line-height: 25px;
  }

  .doc-title {
    margin-top: 12px;
  }

  .not-indent {
    text-indent: 0;
  }

  img {
    margin-top: 20px;
    width: 611px;
  }
}
</style>
